var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4917 2C16.6618 2 15.9882 2.67276 15.9882 3.50266C15.9882 4.33256 16.6618 5.00532 17.4917 5.00532C18.3216 5.00532 18.9952 4.33256 18.9952 3.50266C18.9952 2.67276 18.3216 2 17.4917 2ZM3.08724 15.7104L12.5499 6.25324C13.39 5.4136 14.7521 5.41361 15.5922 6.25324L17.7618 8.42164C18.602 9.26127 18.602 10.6226 17.7618 11.4622L8.29921 20.9194C6.85996 22.3578 4.52649 22.3578 3.08725 20.9194C1.64801 19.481 1.648 17.1489 3.08724 15.7104ZM13.9645 7.66704L11.0008 10.629L13.3836 13.0104L16.3472 10.0484C16.4061 9.98959 16.4061 9.89425 16.3472 9.83544L14.1776 7.66704C14.1187 7.60824 14.0233 7.60824 13.9645 7.66704ZM4.50186 17.1243L9.58621 12.0428L11.9689 14.4242L6.88459 19.5056C6.22662 20.1632 5.15984 20.1632 4.50187 19.5056C3.84389 18.848 3.84389 17.7818 4.50186 17.1243ZM18.9968 12.5186C18.9968 11.6887 19.6704 11.016 20.5003 11.016C21.3302 11.016 22.0039 11.6887 22.0039 12.5186C22.0039 13.3485 21.3302 14.0213 20.5003 14.0213C19.6704 14.0213 18.9968 13.3485 18.9968 12.5186ZM11.4776 2C10.6477 2 9.9741 2.67276 9.9741 3.50266C9.9741 4.33256 10.6477 5.00532 11.4776 5.00532C12.3075 5.00532 12.9811 4.33256 12.9811 3.50266C12.9811 2.67276 12.3075 2 11.4776 2Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic_wand.0c4d24c5f85396e12c60505629f1cd41.svg";
export { ForwardRef as ReactComponent };